import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';
import { format } from 'date-fns';

import type { ClinicalNote } from '../types/api';
import { displayHumanReadableTemplateName } from '../utils';

interface NoteSelectProps {
  clinicalNotes: ClinicalNote[];
  selectedNote: ClinicalNote | undefined;
  onSelectedNote: (value: string | undefined) => void;
}

export const NoteSelect = ({
  clinicalNotes,
  selectedNote,
  onSelectedNote,
}: NoteSelectProps) => {
  return (
    <>
      <Select value={selectedNote?.id ?? ''} onValueChange={onSelectedNote}>
        <SelectTrigger>
          <SelectValue>
            {selectedNote &&
            selectedNote.createdAt &&
            (selectedNote.promptName || selectedNote.templateName)
              ? `${format(
                  new Date(selectedNote.createdAt),
                  'MM/dd/yyyy',
                )} - ${displayHumanReadableTemplateName(selectedNote)} ${
                  selectedNote.id === clinicalNotes[0]?.id ? '[Latest]' : ''
                }`
              : 'Select a clinical note'}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="vai-overflow-visible vai-z-[10001]">
          {clinicalNotes.map((note) => {
            if (!note.createdAt || !(note.promptName || note.templateName)) {
              return null;
            }
            return (
              <SelectItem key={note.id} value={note.id}>
                <div className="vai-flex vai-flex-col vai-whitespace-normal">
                  <span className="vai-font-medium">
                    {`${format(
                      new Date(note.createdAt),
                      'MM/dd/yyyy',
                    )} - ${displayHumanReadableTemplateName(note)} ${
                      note.id === clinicalNotes[0]?.id ? '[Latest]' : ''
                    }`}
                  </span>
                  <span className="vai-text-sm vai-text-muted-foreground">
                    {`${note.user?.firstName || ''} ${note.user?.lastName || ''}`}
                  </span>
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </>
  );
};
